module.exports = __webpack_public_path__ + "assets/img/等待物流公司取件.181ab159.svg";